import { makeStyles } from "@mui/styles";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from "@mui/material";

import { info } from "./helpInfo";

const useStyles = makeStyles({
  root: {
    fontFamily: "Arial",
    width: "90%",
    margin: "auto",
    maxWidth: 1400,
  },
  container: {
    margin: "5rem auto",
  },
});

export default function Help() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}></div>
    </div>
  );
}
